import React, { useRef, useEffect, useState } from "react";
import Sidebar from "../common/Sidebar";
import { Editor } from "@tinymce/tinymce-react";
import "../customCss/Main.css";
import DataService from "../services/data.service";
import { useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Logout from "../common/Logout";


const EditBlog = () => {
  const navigate = useNavigate();
  const editorRef = useRef(null);
  const params = useParams();
  const [blog, setBlog] = useState([]);
  const [blogTitle, setBlogTitle] = useState("");
  const [file, setFile] = useState(null);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState([]);

  const inputFileRef = useRef();
  const imgRef = useRef();
  const onFileChangeCapture = (e) => {
    const file = e.target.files[0];
    setFile(e.target.files);
    const reader = new FileReader();
    const url = reader.readAsDataURL(file);
    reader.onloadend = function (theFile) {
      var image = new Image();
      image.src = theFile.target.result;
      imgRef.current.src = image.src;
    };
  };
  const triggerFile = () => {
    inputFileRef.current.click();
  };
  const getOneBlog = async () => {
    await DataService.getOneBlog(params.id).then((data) => {
      setBlog(data?.data?.data);
      setBlogTitle(data?.data?.data?.heading);
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setMessage("");
    const data = new FormData();
    if (file && file.length > 0) {
      setLoading(true);
      data.append("images", file[0]);
      if (uploadedFiles && uploadedFiles.length > 0) {
        uploadedFiles.some((file) => {
          data.append("images", file);
        });
      }
      data.append("_id",params.id)
      data.append("heading", blogTitle);
      data.append("description", editorRef.current.getContent());
      DataService.addBlog(data).then(
        () => {
          toast.success("Blog Updated Successfully!")
          setTimeout(() => {
            window.location.reload();
          },2000)
        },
        (error) => {
          const resMessage =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
          setLoading(false);
          toast.error(resMessage, {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      );
    } else {
      toast.error("Please Blog Image", {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  };

  useEffect(() => {
    document.title = "Add New Blog";
    window.scrollTo(0, 0);
    getOneBlog();
  }, []);
  return (
    <>
      <div className="main_section">
        <div className="main_flex">
          <div className="main_flexL">
            <Sidebar />
          </div>
          <div className="main_flexR">
            <div className="right_title">
              <h1>Edit Blog</h1>
              <Logout/>
            </div>
            <div className="inter_inner">
              <div class="form-floating mb-3">
                <input
                  type="text"
                  class="form-control"
                  id="floatingInput"
                  placeholder=""
                  required
                  value={blogTitle}
                  onChange={(e) => setBlogTitle(e.target.value)}
                />
                <label for="floatingInput">Blog Title</label>
              </div>
              <div className="form_field">
                <label>Blog Content</label>
                <Editor
                  apiKey="1nolfd56snnawdzchbfmu06ihvzd2nkhvgvdj5i85do1bws6"
                  onInit={(evt, editor) => (editorRef.current = editor)}
                  initialValue={blog?.description}
                  init={{
                    height: 500,
                    menubar: true,
                    plugins: [
                      "advlist",
                      "autolink",
                      "lists",
                      "link",
                      "image",
                      "charmap",
                      "preview",
                      "anchor",
                      "searchreplace",
                      "visualblocks",
                      "code",
                      "fullscreen",
                      "insertdatetime",
                      "media",
                      "table",
                      "code",
                      "help",
                      "wordcount",
                    ],
                    toolbar:
                      "undo redo | blocks | " +
                      "bold italic forecolor | alignleft aligncenter " +
                      "alignright alignjustify | bullist numlist outdent indent | " +
                      "removeformat | help",
                    content_style: "body { font-size:14px }",
                  }}
                />
              </div>
              <div className="row align-items-center">
                <div className="col-sm-4">
                  {blog?.images?.length > 0 ? (
                    <img
                      src={
                        "https://api.milfhub.co.uk/" +
                        blog?.images[0]?.path
                      }
                      onClick={triggerFile}
                      style={{
                        height: "300px",
                        width: "300px",
                        objectFit: "cover",
                      }}
                      ref={imgRef}
                      alt=""
                    />
                  ) : (
                    ""
                  )}
                </div>
               
                <div className="col-sm-8">
                  <div class="form-floating mb-3">
                    <input
                      type="file"
                      class="form-control"
                      id="floatingInput"
                      placeholder=""
                      required
                      ref={inputFileRef}
                      onChangeCapture={onFileChangeCapture}
                    />
                    <label for="floatingInput">Blog Image</label>
                  </div>
                </div>
              </div>

              <div className="submit_sec">
                <button className="main_button" onClick={handleSubmit}>Submit</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditBlog;
